import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="mt-44 py-9 flex items-center justify-center flex-wrap gap-7">
      <div className="logo text-3xl">
        <Link to="/">
          <h1>FATMA</h1>
        </Link>
      </div>
      <div className="links flex gap-5">
        <a
          href="https://www.frontendmentor.io/profile/Fatma-M"
          target="_blank"
          rel="noreferrer">
          <img
            src={require("../assets/icons/frontend-mentor.png")}
            alt="icon"
            className="w-9"
          />
        </a>
        <a href="https://codepen.io/Fatma-m" target="_blank" rel="noreferrer">
          <img
            src={require("../assets/icons/codepen.png")}
            alt="icon"
            className="w-10"
          />
        </a>
        <a href="https://github.com/Fatma-M" target="_blank" rel="noreferrer">
          <img
            src={require("../assets/icons/github.png")}
            alt="icon"
            className="w-9"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/fatma-mohamed-b08569206/"
          target="_blank"
          rel="noreferrer">
          <img
            src={require("../assets/icons/linkedin.png")}
            alt="icon"
            className="w-9"
          />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
